import { getEventStats } from '../../action/events'

export const eventsDashboardLoader = () => {

    getEventStats()

}
